module.exports = __webpack_public_path__ + "static/matilda-feb8844c8b30af553efb8091fb41343d.jpg";